import api from '../../../../api';
import {
  CreateCanvasAssetRequest,
  CreateCanvasAssetResponse,
} from '@dreamai/types';

interface CreateProspectCanvasAssetParams {
  prospectId: string;
  prospectName: string;
  threadId: string;
  getAccessTokenSilently: () => Promise<string>;
}

export const createProspectCanvasAsset = async ({
  prospectId,
  prospectName,
  threadId,
  getAccessTokenSilently,
}: CreateProspectCanvasAssetParams): Promise<void> => {
  try {
    const token = await getAccessTokenSilently();
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    const createRequest: CreateCanvasAssetRequest = {
      threadId: threadId,
      title: `Prospect: ${prospectName}`,
      components: [
        {
          type: 'Prospect',
          props: {
            prospectId: prospectId,
          },
          order: 1,
        },
      ],
    };

    const response = await api.post('/canvas-assets', createRequest);
    const data: CreateCanvasAssetResponse = response.data;

    if (data.success) {
      console.log(
        'Canvas asset created successfully:',
        data.asset?.canvasAssetId,
      );
      // The canvas system will automatically switch to the new asset via pusher events
    } else {
      console.error('Failed to create canvas asset:', data.error);
    }
  } catch (err) {
    console.error('Error creating canvas asset for prospect:', err);
  }
};
